import { Section, Reveal, Overline } from "./primitives";
import { WHY } from "../../data";
import { motion } from "framer-motion";

export default function WhyChoose() {
  return (
    <Section id="why">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto mb-16">
          <Overline>Why Choose VYFT</Overline>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-5xl tracking-tight">
            The unfair advantage of <span className="text-gradient">one partner</span>.
          </h2>
        </div>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {WHY.map((w, i) => (
          <Reveal key={w.title} delay={(i % 4) * 0.06}>
            <motion.div
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 300, damping: 22 }}
              className="group h-full rounded-3xl border border-border/10 bg-card p-7 shimmer-card"
            >
              <div className="h-12 w-12 grid place-items-center rounded-2xl border border-border/15 text-primary group-hover:bg-brand-gradient group-hover:text-white group-hover:border-transparent transition-colors">
                <w.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-display text-lg font-bold">{w.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{w.body}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
